import { gql } from 'apollo-angular';

import { ADDRESS_FRAGMENT } from 'graphql/fragments/address';

export const CUSTOMER_BASE_FRAGMENT = gql`
  fragment CustomerBaseFragment on Customer {
    id
    name
    additionalNames
    email
    baseDiscount
    vat
    customerNumber
    useCustomConditions
    addresses(take: 1) {
      ...AddressFragment
    }
  }
  ${ADDRESS_FRAGMENT}
`;
